module.exports = __webpack_public_path__ + "img/3_icn_sneaker.eb00df74.png";